import { PackageType } from 'common/__generated__/api';

const packageMap = {
  FH  : PackageType.FLIGHT_HOTEL,
  HC  : PackageType.HOTEL_CAR,
  FHC : PackageType.FLIGHT_HOTEL_CAR,
  FC  : PackageType.FLIGHT_CAR
};

export const parsePackageType = (value: string): PackageType => {
  const packageType = packageMap[value.toUpperCase()];

  return packageType || null;
};
